import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import InlineSVG from 'svg-inline-react'
import { createDivAtom } from 'shared/atoms/factory'
import CopyToClipboard from 'react-copy-to-clipboard'

import styles from './Input.module.scss'

import iconCopy from '!raw-loader!shared/assets/icons/copy.svg'

const Wrapper = createDivAtom(),
      InputWrapper = createDivAtom(),
      CopyIconWrapper = createDivAtom(),
      Title = createDivAtom()

const Input = props => {
  const {
    title,
    className,
    onChange,
    value,
    disabled,
    readonly,
    placeholder
  } = props

  return (
    <Wrapper>
      {title && (
        <Title className={styles.title}>
          {title}
        </Title>
      )}

      <InputWrapper className={styles.inputWrapper}>
        <input
          className={classNames(
            styles.input,
            Boolean(className) && className,
            disabled && styles.disabled,
            readonly && styles.readonly
          )}
          onChange={onChange}
          value={value}
          disabled={Boolean(disabled) || Boolean(readonly)}
          placeholder={placeholder}
        />

        {Boolean(readonly) && (
          <CopyToClipboard text={value}>
            <CopyIconWrapper
              className={styles.copyIconWrapper}
              onClick={() => {
                alert('Copied to clipboard')
              }}
            >
              <InlineSVG
                src={iconCopy}
              />
            </CopyIconWrapper>
          </CopyToClipboard>
        )}
      </InputWrapper>
    </Wrapper>
  )
}

Input.defaultProps = {
  disabled: false
}

Input.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.any,
  readonly: PropTypes.any
}

export default Input